import { useEffect, useState, useTransition } from 'react';

import { styled } from '@mui/material';

import { Skeleton } from '../Skeleton';

export type DeferredImageProps = {
  src: string;
  alt: string;
};

export const StyledImage = styled('img')({
  maxWidth: '100%',
  maxHeight: '100%',
});

export const DeferredImage = ({ src, alt }: DeferredImageProps) => {
  const [isPending, startTransition] = useTransition();
  const [imageSource, setImageSource] = useState<string>('');

  useEffect(() => {
    setTimeout(() => {
      startTransition(() => {
        setImageSource(src);
      });
    });
  }, [src]);

  if (isPending || !imageSource)
    return <Skeleton borderRadius={1} margin="0" height="100%" width="100%" />;

  return <StyledImage src={`data:image/png;base64,${imageSource}`} alt={alt} />;
};
